import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../utils/serviceHelper";
import { getMeridioPlanCatalog } from "../../services/api/benefits/meridioPlanCatalog/getMeridioPlanCatalog";
import { IMeridioPlanCatalogResponse } from "../../services/api/benefits/meridioPlanCatalog/types";

export const QUERY_MERIDIO_PLAN_CATALOG = "QUERY_MERIDIO_PLAN_CATALOG";

export const useQueryMeridioPlanCatalog = (
  config?: WSQueryConfig<IMeridioPlanCatalogResponse, WSServiceError>
) =>
  useWSQuery<IMeridioPlanCatalogResponse, WSServiceError>(
    QUERY_MERIDIO_PLAN_CATALOG,
    getMeridioPlanCatalog,
    config
  );
